import React from "react";
import { Link } from "react-router-dom";

const SERVICE_LINKS = [
  { label: "Data Products", to: "/services/data-products-engineering" },
  { label: "Research", to: "/services/research-analysis" },
  { label: "Storytelling", to: "/services/communication-storytelling" },
  { label: "Publishing", to: "/services/distribution-reach" },
  { label: "Fresh Data", to: "/services/fresh-data-updates" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-6">
              <img
                src="/brand/onlyfacts-logo-white.png"
                alt="OnlyFacts"
                className="h-8 w-auto select-none"
                draggable="false"
              />
              <span className="overline text-[#FDE047]">Studio</span>
            </div>
            <p className="text-white/70 text-base leading-relaxed max-w-sm">
              Custom tools and content that turn data into a case.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-white/50 mb-4">Services</p>
            <ul className="space-y-3">
              {SERVICE_LINKS.map((s, i) => (
                <li key={s.to}>
                  <Link
                    to={s.to}
                    data-testid={`footer-service-${i}`}
                    className="inline-flex items-baseline gap-2 text-white/80 hover:text-white text-sm link-ink"
                  >
                    <span className="font-mono text-[0.65rem] text-white/40">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-white/50 mb-4">Get in touch</p>
            <a
              href="mailto:studio@onlyfacts.io"
              data-testid="footer-email"
              className="font-display font-black text-2xl md:text-3xl hover:text-[#FDE047] transition-colors break-words"
            >
              studio@onlyfacts.io
            </a>
            <div className="mt-6 flex gap-3">
              <a href="https://onlyfacts.io" target="_blank" rel="noreferrer" className="border border-white/20 px-4 py-2 text-sm hover:bg-white hover:text-[#0A0A0A] transition-colors">
                Platform
              </a>
              <a href="/#contact" 
                onClick={() => window.gtag?.('event', 'cta_click', { location: 'footer' })} 
                className="bg-[#FDE047] text-[#0A0A0A] px-4 py-2 text-sm font-medium hover:bg-white transition-colors">
                Start project
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/15 pt-6">
          <p className="text-white/50 text-xs font-mono">
            © {new Date().getFullYear()} OnlyFacts Studio · Australia's Fact Tank
          </p>
        </div>
      </div>
    </footer>
  );
}
